import { ErrorHandler, Injectable } from '@angular/core';
import { LoggingService } from './logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private loggingService: LoggingService) {}

  handleError(error: any): void {
    this.loggingService.logEvent('uncaught_exception', {
      
      error_message: error.message || 'Uncaught error',
      error_stack: error.stack || null
    });
    console.error('Uncaught error:', error);
  }
}
